module.exports = __webpack_public_path__ + "973073d866af14407314d7b867c0fc66.woff2";